module.exports = __webpack_public_path__ + "img/mastercard-logo.eb45fe07.png";